import {css} from "styled-components";

const variantOptions = {
    standard: css`
        border: none;
        color: var(--button-second-color, green);
        background: var(--button-first-color, black);
        
        &:hover {
            background-color: var(--button-first-color, green) !important;
            color: var(--button-second-color, black) !important;
        }
    `,
    outline: css`
        &, &:hover {
            border: solid 1px var(--button-first-color, black) !important;
            color: var(--button-first-color, black) !important;
            background-color: transparent !important;
        }
    `,
    outlineDiffIn: css`
        &, &:hover {
            border: solid 1px var(--button-first-color, black) !important;
            color: var(--button-second-color, black) !important;
            background-color: transparent !important;
        }
    `,
    outlineBlack: css`
        &, &:hover {
            border: solid 1px black !important;
            color:  black !important;
            background-color: transparent !important;
        }
    `,
    link: css`
        border: none;
        width: max-content;
        display: inline-block;
        text-decoration: none;

        &, &:hover {
            background-color: unset !important;
            color: var(--button-first-color, #000) !important;
        }

        span {
            text-decoration: underline;
            padding: 0;
        }
        
        div[style] {
            display: none;
        }
    `,
    icon: css`
        aspect-ratio: 1/1;
        color: var(--button-second-color, green);
        background: var(--button-first-color, black);
    `,
    circle: css`
        border-radius: 50%;
        aspect-ratio: 1/1;
        color: var(--button-second-color, green);
        background: var(--button-first-color, black);
    `,
    none: css`
        background: transparent;
        padding: 0 !important;
        border: none;
    `
}

export const getVariantStyles = ({variant}) => variantOptions[variant] ?? variantOptions['standard']
